// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"105":"css/app-rtl","252":"css/app"}[chunkId] + ".css";
};